<template>
<div class="chapter">
<div class="inner_page">
<p class="p10">Again and always, for J.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?7b55cd21